<template>
    <div style="text-align: center;">
        <a-avatar class="UserInfoImg" :size="64" style="color: #f56a00; backgroundColor: #fde3cf">{{ Username }}</a-avatar>
        <div class="UserInfoCountDiv">
            <div class="UserInfoCountNumberDiv" @click="PersonalCenter('Answer')">
                <label class="UserInfoCountNumber">{{ UserInfoData.aNum }}</label>
                <label class="UserInfoCountType">{{ i18n.$t('UserinfoAnswer') }}</label>
            </div>
            <div class="UserInfoCountNumberDiv" @click="PersonalCenter('Question')" v-if="Group != 'ROLE_aftersale2'">
                <label class="UserInfoCountNumber">{{ UserInfoData.pNum }}</label>
                <label class="UserInfoCountType">{{ i18n.$t('UserinfoQuestion') }}</label>
            </div>
            <div class="UserInfoCountNumberDiv" v-if="Group == 'ROLE_aftersale2'">
                <label class="UserInfoCountNumber">{{ UserInfoData.pNum }}</label>
                <label class="UserInfoCountType">{{ i18n.$t('UserinfoQuestion') }}</label>
            </div>
        </div>
        <div class="UserInfoButtonDiv" v-if="Group != 'ROLE_aftersale2'">
            <label class="UserInfoButtonQuestion" @click="AskQuestion()">{{ i18n.$t('UserInfoAskQuestion') }}</label>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useI18n } from "@/i18nPlugin";
import { useRouter } from 'vue-router';
import { 
    SearchAccountData
} from '../../api/index';
export default defineComponent({
    setup() {
        const i18n = useI18n();
        const router = useRouter();
        const token = localStorage.getItem("userToken");
        const Group = localStorage.getItem("Group");
        const Username = ref(localStorage.getItem("userName_ats"));
        const UserInfoData = ref({})
        const AskQuestion = () => {
            router.push({ path: '/ATS/BBSEdit'});
        }

        const PersonalCenter = (type) => {
            router.push({ path: '/ATS/PersonalCenter', query: { type: type }});
        }

        const SearchAccount = () => {
            SearchAccountData (token).then(res => {   
                // console.log(res)
                UserInfoData.value = res.data;
            }).catch(error => console.log(error));
        };

        return {
            i18n,
            Username,
            Group,
            UserInfoData,
            AskQuestion,
            PersonalCenter,
            SearchAccount
        }
    },
    mounted() {
        // console.log(this.Username)
        if (this.Username != undefined) {
            this.SearchAccount();
        }
    }
})
</script>

<style scoped>
    .UserInfoImg {
        margin-top: 47px;
    }
    .UserInfoCountDiv {
        margin-top: 20px;
        margin-left: 100px;
        text-align: left;
    }
    .UserInfoCountNumberDiv {
        cursor: pointer;
        width: 84px;
        padding: 0 16px;
        text-align: center;
        display: inline-block;
    }
    .UserInfoCountNumber {
        cursor: pointer;
        display: block;
        font-size: 14px;
        color: #353535;
        letter-spacing: 0;
        text-align: center;
    }
    .UserInfoCountType {
        cursor: pointer;
        margin-top: 12px;
        display: block;
        font-size: 14px;
        color: #939393;
        letter-spacing: 0;
    }
    .UserInfoButtonDiv {
        margin-top: 30px;
        margin-left: -30px;
        margin-bottom: 18px;
        text-align: center;
    }
    .UserInfoButtonQuestion {
        cursor: pointer;
        padding: 6px 60px;
        font-size: 16px;
        color: #03a0d6;
        letter-spacing: 0;
        background-color: #FFFFFF;
        border: 1px solid #03a0d6;
        border-radius: 15px;
        margin-left: 30px;
    }
</style>